<template>
    <div class="keyword_box feeUncollected_table">
        <div>
			<el-table
			:data="tableData"
			border
			class="roster_table"
			style="width: 100%">
				<el-table-column
				prop="venueName"
				align="left"
				label-class-name="roster_th"
				class-name="roster_row"
				label="VENUE NAME">
				</el-table-column>
				<el-table-column
				prop="venueOwner"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="VENUE OWNER">
				</el-table-column>
				<el-table-column
				prop="contactNumber"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="CONTACT NUMBER">
					<!-- 0412 341 234 -->
				</el-table-column>
				<el-table-column
				prop="paymentCard"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				width="195"
				label="CARD DETAILS">
					<!-- **** **** **** 1234 -->
				</el-table-column>
				<el-table-column
				prop="monthlyFee"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="MONTHLY FEE">
					<template slot-scope="scope">
						${{scope.row.monthlyFee?scope.row.monthlyFee:'0.00'}}
					</template>
				</el-table-column>
				<el-table-column
				prop="name"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="AMOUNT RECEIVED">
					<template slot-scope="scope">
						${{scope.row.amountReceived?scope.row.amountReceived:'0.00'}}
					</template>
				</el-table-column>
				<el-table-column
				prop="chargeTime"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
                width="220"
				label="CHARGE TIME">
					<template slot-scope="scope">
						{{scope.row.chargeTime}}
					</template>
				</el-table-column>
			</el-table>
			<div class="ros_footerPage">
				<el-pagination
					class="my_pageSel"
					:current-page.sync="page"
					@current-change='changePage'
					layout="prev, pager, next"
					:page-size="10"
					:total="total">
				</el-pagination>
			</div>
		</div>
    </div>
</template>

<script>
import api from '../../api/fee'
export default {
	props:{
		keyword:{
            type: String,
            default: () => {
                return '';
            }
        },
		status:{
            type: Number,
            default: () => {
                return 1;
            }
        },
		isSearch:{
            type: Boolean,
            default: () => {
                return false;
            }
        },
		month:{
            type: String,
            default: () => {
                return window.sessionStorage.getItem('month');
            }
        },
	},
    data() {
        return {
			tableData:[],
			page:1,
			size:10,
			total:0,
			loading:false
        }
	},
	mounted() {
		this.getList()
	},
    methods: {
		changePage(page){
            this.page=page
            this.getList()
        },
		getList(){
            this.loading=true
            let pat={
                pageNum:this.page,
				pageSize:this.size,
				keyword:this.keyword,
				month:this.month,
				status:1
            }
            api.getPlatformFeesList({params:pat,callback:res=>{
                this.loading=false
                let {code,message,data}=res.data;
                this.loading2=false;
                if(code==0){
                    this.tableData=data.list;
					this.total=data.receivedTotal;
					this.$emit('accept',data.uncollectedTotal,data.receivedTotal)
                    this.tableData.forEach(item=>{
                        item.chargeTime=Utils.timestampToTimeNew(item.chargeTime)
                        item.monthlyFee=Utils.formatSplit(item.monthlyFee)
                        item.amountReceived=Utils.formatSplit(item.amountReceived)
                    })
                }else{
                    this.$box.alert('', res.data.message, 'error')
                }
            }})
        }
	},
	watch: {
		isSearch(n,o){
			n?this.getList():''
		}
	}
}
</script>

<style lang="scss">
    .keyword_box{
		box-sizing: border-box;
		background-color: #2b3444;
		padding: 50px 30px;
		.ros_footerPage{
			display: flex;
			justify-content: center;
        }
        .key_tableBtn_group{
            display: flex;
            justify-content: flex-end;
        }
        .redebit_btn{
            width:100px;
            height:40px;
            background:rgba(21,28,39,1);
            border:1px solid #fff;
            font-size:18px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            cursor: pointer;
		}
    }
</style>


// WEBPACK FOOTER //
// src/components/fee/received.vue